module.exports = __webpack_public_path__ + "img/13ne.726e4d85.svg";